import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ficheApi } from "./api";

export const useFiche = (id: string) =>
  useQuery({ queryKey: ["fiche", id], queryFn: () => ficheApi.complete(id) });

/** Infirmer un constat recalcule le score côté serveur : fiche et portefeuille sont invalidés. */
export function useVerifierSignal(prospectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { signalId: string; statut: "confirme_client" | "infirme_client" | "non_verifie" }) =>
      ficheApi.verifierSignal(v.signalId, v.statut),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["fiche", prospectId] });
      qc.invalidateQueries({ queryKey: ["recherche"] });
    }
  });
}

export function useGenererArgumentaire(prospectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => ficheApi.genererArgumentaire(prospectId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["fiche", prospectId] })
  });
}
